import { useQuery } from "@tanstack/react-query"
import { runningCustomerImportsQuery } from "../lib/runningCustomerImportsQuery"

export function useRunningCustomerImportsQuery() {
  return useQuery(runningCustomerImportsQuery())
}
